import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { GET_CHAT_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { usePageMessages } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const EqualNameAndNameFPopup = ({ popupRef = null, ...props }) => {
    const { nameNameFMatchingDesc, goBackAndEditButton, contactSupport } = usePageMessages();
    return (
        <SimplePopup text={MarkdownService.splitByParagraph(nameNameFMatchingDesc)} popupRef={popupRef}>
            <PopupButton
                iconName="arrow-back-circular"
                text={goBackAndEditButton}
                onClick={() => {
                    popupRef.current?.close();
                }}
            />
            <PopupButton
                iconName="lifebuoy"
                text={contactSupport}
                onClick={() => {
                    amplitude.getInstance().logEvent(GET_CHAT_CLICKED);
                    popupRef.current?.close();
                    props.toggleChat(true);
                }}
            />
        </SimplePopup>
    );
};

EqualNameAndNameFPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { toggleModal, toggleChat })(EqualNameAndNameFPopup);
